import { createRouter, createWebHistory } from 'vue-router';

// Layouts
import DashboardLayout from '../layouts/DashboardLayout.vue';
import AuthLayout from '../layouts/AuthLayout.vue';

// Views
import Login from '../views/auth/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Users from '../views/users/Index.vue';
import UserForm from '../views/users/Form.vue';
import Roles from '../views/roles/Index.vue';
import RoleForm from '../views/roles/Form.vue';
import NotFound from '../views/NotFound.vue';
import Unidad from '../views/unidad/Index.vue';
import UnidadForm from '../views/unidad/Form.vue';
import Area from '../views/areas/Index.vue';
//import AreaForm from '../views/areas/Form.vue';
import Valorado from '../views/tipostramites/Valorado.vue';
import Informe from '../views/reportes/Informe.vue';

import TipoTramite from '../views/tipostramites/TipoTramite.vue'
import TipoTramiteDetail from '../views/tipostramites/VerTipoTramite.vue';
import Tramite from '../views/tramites/Tramite.vue'
import TramiteDetail from '../views/tramites/VerTramite.vue'
import Persona from '../views/tramites/Persona.vue';
import TramiteProceso from '../views/tramites/TramiteProceso.vue';
import TramiteAprobar from '../views/tramites/TramiteAprobar.vue';
import TramiteEntrega from '../views/tramites/TramiteEntrega.vue';
import ReporteEconomico from '../views/reportes/ReporteEconomico.vue';
import ReporteEco from '../views/reportes/ReporteEco.vue';
import ReporteValorados from '../views/reportes/ReporteValorados.vue';

import TramiteInforme from '../views/tramites/TramiteInfo.vue';
//sistema almacen
import Compras from '../views/compras/Index.vue';
import ComprasDetalle from '../views/compras/Detalle.vue';
import Entradas from '../views/entradas/Index.vue';
import Salidas from '../views/salidas/Index.vue';
import SalidasDetalle from '../views/salidas/Detalles.vue';
import Categoria from '../views/compras/Categoria.vue';
import Item from '../views/compras/Item.vue';
import Proveedor from '../views/compras/Proveedor.vue';
import Partida from '../views/compras/Partida.vue';
import ReporteStock from '../views/reportes/StockReport.vue';
import ReporteKardex from '../views/reportes/KardexReport.vue';
import AlmacenReport from '../views/reportes/AlmacenReport.vue';

import Ventanilla from '../views/ventanilla/Index.vue';
import VentanillaDetalle from '../views/ventanilla/Detalle.vue';
import VentanillaReporte from '../views/ventanilla/Reporte.vue';

import ResumenAlmacen from '../views/reportes/ResumenAlmacen.vue';

import SolicitudContratacion from '../views/contrataciones/Index.vue';
import DetalleSolicitudContratacion from '../views/contrataciones/InformacionGeneral.vue';
import SolicitudContratacionShow from '../views/contrataciones/Show.vue';

import Recurso from '../views/contrataciones/Recurso.vue';
import ParametrosPoa from '../views/contrataciones/ParametrosPoa.vue';

import Tickets from '../views/tickets/TicketGenerator.vue';
import Pantalla from '../views/tickets/PantallaLlamadas.vue';
import VentanillaPanel from '../views/tickets/VentanillaPanel.vue';
import ReporteTicket from '../views/tickets/ReporteTicket.vue';
import ReporteEstadoTramites from '../views/reportes/ReporteEstadoTramite.vue';

const routes = [
    {
        path: '/',
        component: DashboardLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'dashboard',
                component: Dashboard
            },
            {
                path: 'users',
                name: 'users',
                component: Users,
                meta: { permission: 'user_read' }
            },
            {
                path: 'users/create',
                name: 'users.create',
                component: UserForm,
                meta: { permission: 'user_create' }
            },
            {
                path: 'users/:id/edit',
                name: 'users.edit',
                component: UserForm,
                meta: { permission: 'user_update' }
            },
            {
                path: 'roles',
                name: 'roles',
                component: Roles,
                meta: { permission: 'role_read' }
            },
            {
                path: 'roles/create',
                name: 'roles.create',
                component: RoleForm,
                meta: { permission: 'role_create' }
            },
            {
                path: 'roles/:id/edit',
                name: 'roles.edit',
                component: RoleForm,
                meta: { permission: 'role_update' }
            },
            {
                path: 'unidad',
                name: 'unidad',
                component: Unidad
            },
            {
                path: 'unidad/create',
                name: 'unidad.create',
                component: UnidadForm
            },
            {
                path: 'unidad/edit/:id',
                name: 'unidad.edit',
                component: UnidadForm
            },
            {
                path: 'area',
                name: 'area',
                component: Area
            },
            {
                path: 'valorado',
                name: 'valorado',
                component: Valorado
            },
            {
                path: 'informe',
                name: 'informe',
                component: Informe
            },
            {
                path: 'tipotramite',
                name: 'tipotramite',
                component: TipoTramite
            },
            {
                path: 'tipotramite/detail/:id',
                name: 'tipotramite.detail',
                component: TipoTramiteDetail
            },
            {
                path: 'tramite',
                name: 'tramite',
                component: Tramite
            },
            {
                path: 'tramite/detail/:id',
                name: 'tramite.detail',
                component: TramiteDetail
            },
            {
                path: 'tramite/proceso',
                name: 'tramite.proceso',
                component: TramiteProceso
            },
            {
                path: 'tramiteAprobar',
                name: 'tramiteAprobar',
                component: TramiteAprobar
            },
            {
                path: 'tramiteEntrega',
                name: 'tramiteEntrega',
                component: TramiteEntrega
            },
            {
                path: 'persona',
                name: 'persona',
                component: Persona
            },
            {
                path: 'reporteEconomico',
                name: 'reporteEconomico',
                component: ReporteEconomico
            },
            {
                path: 'reporteEco',
                name: 'reporteEco',
                component: ReporteEco
            },
            {
                path: 'reporteValorados',
                name: 'reporteValorados',
                component: ReporteValorados
            },
            {
                path: 'items',
                name: 'items',
                component: Item
            },
            {
                path: 'categorias',
                name: 'categorias',
                component: Categoria
            },
            {
                path: 'proveedores',
                name: 'proveedores',
                component: Proveedor
            },
            {
                path: 'partidas',
                name: 'partidas',
                component: Partida
            },
            {
                path: 'compras',
                name: 'compras',
                component: Compras
            },
            {
                path: '/compras/:id/detalle',
                name: 'compras-detalle',
                component: ComprasDetalle
            },
            {
                path: 'entradas',
                name: 'entradas',
                component: Entradas
            },
            {
                path: 'salidas',
                name: 'salidas',
                component: Salidas
            },
            {
                path: 'reporte-stock',
                name: 'reporte-stock',
                component: ReporteStock
            },
            {
                path: 'reporte-kardex',
                name: 'reporte-kardex',
                component: ReporteKardex
            },
            {
                path: '/salidas/:id/detalle',
                name: 'salidas-detalle',
                component: SalidasDetalle,
                props: true,
            },
            {
                path: 'reporte-almacen',
                name: 'reporte-almacen',
                component: AlmacenReport,
                props: true,
            },
            {
                path: 'ventanilla',
                name: 'ventanilla',
                component: Ventanilla
            },
            {
                path: '/ventanilla/:id/detalle',
                name: 'ventanilla-detalle',
                component: VentanillaDetalle
            },
            {
                path: '/ventanillaReporte',
                name: 'ventanillaReporte',
                component: VentanillaReporte
            },
            {
                path: '/resumenalmacen',
                name: 'resumenalmacen',
                component: ResumenAlmacen
            },
            {
                path: '/contratacion/solicitudes',
                name: 'solicitud-contratacion',
                component: SolicitudContratacion
            },
            {
                path: '/contratacion/solicitudes/create',
                name: 'solicitud-contratacion-create',
                component: SolicitudContratacion
            },
            {
                path: '/contratacion/solicitudes/:id/edit',
                name: 'solicitud-contratacion-edit',
                component: SolicitudContratacion
            },
            {
                path: '/solicitudes-contratacion/show/:id',
                name: 'solicitud-contratacion-show',
                component: SolicitudContratacionShow
            },
            {
                path: '/solicitudes-contratacion/detalle/:id',
                name: 'solicitud-contratacion-detalle',
                component: DetalleSolicitudContratacion
            },
            {
                path: '/contratacion/recursos',
                name: 'recursos',
                component: Recurso
            },
            {
                path: '/contratacion/parametros',
                name: 'parametros',
                component: ParametrosPoa
            },
            {
                path: '/ticket/reporte',
                name: 'ticket-reporte',
                component: ReporteTicket
            },
            {
                path: '/tramites/reporteestado',
                name: 'tramites-reporteestado',
                component: ReporteEstadoTramites
            },

        ]
    },
    {
        path: '/auth',
        component: AuthLayout,
        meta: { guest: true },
        children: [
            {
                path: 'login',
                name: 'login',
                component: Login
            }
        ]
    },

    {
        path: '/tramite/informe/:id',
        name: 'tramite.informe',
        component: TramiteInforme
    },

    {
        path: '/tickets/',
        name: 'tikets.generar',
        component: Tickets
    },
    {
        path: '/pantalla/',
        name: 'pantalla.llamar',
        component: Pantalla
    },
    {
        path: '/ventanilla/panel',
        name: 'ventanilla.panel',
        component: VentanillaPanel
    },

    {
        path: '/login',
        redirect: '/auth/login'
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: 'active'
});

// Guardia de navegación
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userPermissions = user.permissions || [];

    // Verificar si la ruta requiere autenticación
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            next({ name: 'login' });
            return;
        }

        // Verificar permisos
        if (to.meta.permission && !userPermissions.includes(to.meta.permission)) {
            next({ name: 'dashboard' });
            return;
        }
    }

    // Redirigir al dashboard si está autenticado e intenta acceder a páginas de invitados
    if (to.matched.some(record => record.meta.guest) && token) {
        next({ name: 'dashboard' });
        return;
    }

    next();
});

export default router;
